@if (tile && tile_ready) {
  <div class="dashboard-tile"
     [ngClass]="{'text-editing': tileData.editingSubject.value && (tile.attributes.content==='paragraph' || tile.attributes.content==='custom' ),
     'showing-comments': headerData.showing_comments,
     'pivot-ng-editing': pivotEditing && tile.attributes.content === 'pivot-tile-ng',
     'tile-editing': tileData.editingSubject.value, 'tile-dtp': tile.attributes?.parameters?.show_dtp,
     'no-format': tile.attributes.show_header===false}"
    [ngStyle]="{'border-color':tile.attributes.category ? tile.attributes.category.colour : '' }">
    <div class="row tile-header" (dblclick)="editConditional(tile.attributes.content)"
      [ngStyle]="{'background-color':tile.attributes.category ? tile.attributes.category.colour : '' }">
      <div class="row">
        <audit-mixin-indicator [model]="tile"></audit-mixin-indicator>
        <h2>
          <page-tile-menu [tileContent]="tile.attributes.content" [tileId]="tile.id"
          [sessionStateId]="current_session_id"></page-tile-menu>
          <div [appProcessMenu]="tile.attributes?.parameters?.process">{{title}}</div>
          <span>{{sub_title}}</span>
        </h2>
      </div>
      @if (!tile.attributes.hide_edit) {
        <div [class.hidden-header]="tile.attributes.show_header===false"
          class="tile-header-right">
          @if (dateInst.dtp) {
            <div class="date-period-range-select"
              [ngClass]="{'allow-range-select': tile.attributes.custom_dtp && !tile.attributes.relative_dtp}">
              @if (tile.attributes.custom_dtp && !tile.attributes.relative_dtp) {
                <mat-select
                  (selectionChange)="selectCustomDtp()" [(value)]="dateInst.dtp.range"
                  [disabled]="tile.attributes.custom_dtp!==true"
                  [matTooltipDisabled]="tile.attributes.custom_dtp!==true"
                  [matTooltip]="(dateInst.dtp.calendar | upperfirst ) + ': ' + (dateInst.dtp.range | upperfirst )"
                  class="range-select hideonprint"
                  placeholder="Select Range">
                  @for (range of dateTimePeriodService.ranges; track range) {
                    <mat-option
                      [value]="range.range">{{range.range | removeUnderscore | upperfirst}}
                    </mat-option>
                  }
                  <mat-option (click)="selectCustomDtp()" value="custom">Custom</mat-option>
                </mat-select>
              }
              @if (tile.attributes.custom_dtp &&  !tile.attributes.relative_dtp) {
                <div
                  class="displayonprint">{{dateInst.dtp | dateTimePeriod}}
                </div>
              }
              @if (tile.attributes.custom_dtp && tile.attributes.relative_dtp) {
                <div
                  [matTooltip]="dateInst.dtp | dateTimePeriod">Relative
                </div>
              }
            </div>
          }
          @if (!tile.attributes.hide_edit && allowEdit(tile.attributes.content) && edit_mode) {
            <div [matMenuTriggerFor]="menu" class="hide-xs hideonprint tile-edit-menu-trigger"><i class="edit-no-text"></i>
          </div>
          <mat-menu #menu="matMenu" class="tile-menu">
            @if ((['paragraph','custom'].includes(tile.attributes.content)) && allowEdit(tile.attributes.content) &&
              tile.attributes.parameters?.hasOwnProperty('paragraph_body')) {
              <button
                (click)="tileData.setEditing(false);openTextFormDialog(tile.attributes.content)"
                mat-menu-item>Edit text<i class="fa fa-paragraph"></i></button>
              }
              @if ((editableLayoutTables.includes(tile.attributes.content)) && !editing && allowEdit(tile.attributes.content)) {
                <button
                  (click)="tileData.setEditing(true);"
                  mat-menu-item>Edit layout<i class="fa fa-paragraph"></i></button>
                }
                @if (((tile.attributes.content==='pivot-tile' || tile.attributes.content==='pivot-tile-ng') && !pivotEditing)) {
                  <button (click)="buttons[0].func();pivotEditing=!pivotEditing"
                    mat-menu-item>Edit pivot<i class="fa fa-edit"></i></button>
                  }
                  @if (((tile.attributes.content==='pivot-tile' || tile.attributes.content==='pivot-tile-ng') && pivotEditing)) {
                    <button (click)="buttons[1].func();pivotEditing=!pivotEditing"
                      mat-menu-item>Save pivot<i class="fa fa-save"></i></button>
                    }
                    @if ((tile.attributes.content==='model-pivot-tile' && !modelPivotEditing)) {
                      <button (click)="buttons[0].func();modelPivotEditing=!modelPivotEditing"
                        mat-menu-item>Edit pivot<i class="fa fa-edit"></i></button>
                      }
                      @if ((tile.attributes.content==='model-pivot-tile' && modelPivotEditing)) {
                        <button (click)="buttons[1].func();modelPivotEditing=!modelPivotEditing"
                          mat-menu-item>Save pivot<i class="fa fa-save"></i></button>
                        }
                        @if (tile.attributes.content==='value-driver-tree') {
                          <button (click)="buttons[0].func();saveContent(tile);"
                            mat-menu-item>Save zoom<i class="fa fa-save"></i></button>
                          }
                          @if ((editableLayoutTables.includes(tile.attributes.content)) && editing) {
                            <button (click)="tileData.setEditing(false);saveContent(tile);"
                              mat-menu-item>Save layout<i class="fa fa-save"></i></button>
                            }
                            @if ((editableLayoutTables.includes(tile.attributes.content)) && editing) {
                              <button
                                (click)="tileData.setEditing(false);"
                                mat-menu-item>Cancel<i class="fa fa-ban"></i></button>
                              }
                              <button (click)="openTileFormDialog();" [disabled]="appScope.current_user.restricted_access" mat-menu-item
                                title="{{appScope.current_user.restricted_access? 'You do not have rights to edit this tile':'Edit tile'}}"
                                >Edit tile<i class="fa fa-edit"></i></button>
                                <button (click)="deleteTile()" [disabled]="appScope.current_user.restricted_access"
                                  mat-menu-item
                                  title="{{appScope.current_user.restricted_access? 'You do not have rights to edit this tile':'Delete tile'}}"
                                  >Delete tile<i class="fa fa-trash"></i></button>
                                </mat-menu>
                              }
                            </div>
                          }
                          @if (show_date_picker) {
                            <div #dtp_picker class="dtp_picker form-dialog">
                              <date-time-period [disabled]="!tile.attributes.custom_dtp" [immutable]="false" [no_url]="true"
                              class="date-period inline"></date-time-period>
                              <div class="action-buttons">
                                <button (click)="onCloseDtpSelector()" class="btn-close">Close</button>
                                <button (click)="useCustomDtp()" class="btn-save">Select</button>
                              </div>
                            </div>
                          }
                        </div>
                        <!--Tile Content-->
                        <div overlay-scrollbars [defer] [options]="scrollbarOptions" [ngClass]="tile.attributes.content"
                          class="tile-content">
                          @if (show_no_data) {
                            <div class="tile-no-data" [ngStyle]="show_no_data.styles ? show_no_data.styles : ''">
                              {{show_no_data.message || 'No data to display.'}}
                              <i class="fa fa-times hideonprint" matTooltip="Hide" (click)="show_no_data='';"></i></div>
                            }
                            @if (tile.attributes.parameters && tile.attributes.parameters.show_dtp) {
                              <date-time-period
                              class="date-period inline align-bottom"></date-time-period>
                            }
                            @if (tile.attributes.content=='paragraph') {
                              <div style="height: 100%; width: 100%; min-height:50px;">
                                <paragraph [config]="tile.attributes.parameters"
                                  [show_header]="tile.attributes.show_header"
                                  >
                                </paragraph>
                              </div>
                            }
                            <!--Added temporarily during printing-->
                            @if (tile.attributes.content==='print-header-tile') {
                              <print-header-tile></print-header-tile>
                            }
                            @if (tile.attributes.content==='print-footer-tile') {
                              <print-footer-tile
                              [config]="tile.attributes.parameters"></print-footer-tile>
                            }
                            <!--End printing-->
                            <!--Comments tables-->
                            @if (tile.attributes.content==='comment-tile') {
                              <comments-table
                              [config]="tile.attributes.parameters"></comments-table>
                            }
                            @if (tile.attributes.content==='page-comment-table') {
                              <page-comment-table
                              [config]="tile.attributes.parameters"></page-comment-table>
                            }
                            <!--End comments tables-->
                            @if (tile.attributes.content==='custom') {
                              <custom-html
                                [config]="tile.attributes.parameters"
                              [show_header]="tile.attributes.show_header"></custom-html>
                            }
                            @if (tile.attributes.content==='data-exceptions-table') {
                              <data-exceptions-table>
                              </data-exceptions-table>
                            }
                            @if (tile.attributes.content==='flowchart' && flowchartReady) {
                              <flow-chart title="{{tile.attributes.parameters.process.attributes.name}}"
                                (contextMenu)="contextMenu($event)" [chartData]="flowchart" class="flowchart-tile">
                              </flow-chart>
                              <div #context_menu
                                [ngStyle]="{'display':menuVisible? 'block':'none'}"
                                class="menu flowchart-context-menu">
                                <ul class="menu-options">
                                  @if (selectedComponent?.data.attributes?.base_type==='process' &&
                                    selectedComponent?.is_parent !== true) {
                                    <li class="menu-option" style="cursor:default;padding:0;">
                                      <a (click)="changeProcess(selectedComponent)">
                                        Zoom In
                                      </a>
                                    </li>
                                  }
                                  @if (selectedComponent?.data.attributes?.base_type==='process' &&
                                    selectedComponent?.is_parent === true && selectedComponent?.data.relationships.parent.data) {
                                    <li
                                      class="menu-option" style="cursor:default;padding:0;">
                                      <a (click)="changeProcess(selectedComponent?.data.relationships.parent)">
                                        Zoom Out
                                      </a>
                                    </li>
                                  }
                                  @if (selectedComponent?.data.attributes?.base_type==='process') {
                                    <li
                                      class="menu-option" style="cursor:default;padding:0;">
                                      <a
                                        [attr.href]="flowchartUrl()"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        (click)="menuVisible=false; $event.stopPropagation()"
                                        >
                                        Open flowchart
                                      </a>
                                    </li>
                                  }
                                  @if (selectedComponent?.data?.type==='process' && selectedComponent?.pagelinks().length) {
                                    @for (page of selectedComponent.pagelinks(); track page.id) {
                                      <li
                                        class="menu-option" style="cursor:default;padding:0;">
                                        <a [routerLink]="'/view/page_view/' + page.id">
                                          Link to {{page.title}}
                                        </a>
                                      </li>
                                    }
                                  }
                                </ul>
                              </div>
                            }
                            <!--Charts-->
                            @if (tile.attributes.content==='custom-chart' && tile.attributes.parameters.chart_type==='stacked bar') {
                              <bar-chart
                                [config]="tile.attributes.parameters"
                              class="chart"></bar-chart>
                            }
                            @if (tile.attributes.content==='comparison-chart') {
                              <comparison-chart [config]="tile.attributes.parameters"
                                class="chart">
                              </comparison-chart>
                            }
                            @if (tile.attributes.content=='default-chart' || tile.attributes.content=='budget-bar-chart') {
                              <default-chart
                                class="chart" style="width: 90%; height: 90%;"
                                [config]="tile.attributes.parameters" [type]="tile.attributes.content"
                                [hide_comments]="tile.attributes.parameters.hide_comments"
                                [show_data_labels]="tile.attributes.parameters.show_data_labels"
                                [hide_cumulative]="tile.attributes.parameters.hide_cumulative">
                              </default-chart>
                            }
                            @if ((tile.attributes.content==='custom-chart' || tile.attributes.content==='spc-chart')
                              && !['stacked bar', 'rar', 'progress tracker'].includes(tile.attributes.parameters.chart_type)) {
                              <generic-chart
                                [config]="tile.attributes.parameters"
                                class="chart">
                              </generic-chart>
                            }
                            @if (tile.attributes.content==='progress-tracker-chart') {
                              <progress-tracker-chart
                              [config]="tile.attributes.parameters"></progress-tracker-chart>
                            }
                            @if (tile.attributes.content==='custom-chart' && tile.attributes.parameters.chart_type==='rar') {
                              <rar-chart
                                [config]="tile.attributes.parameters"
                              class="plotly-chart"></rar-chart>
                            }
                            @if (tile.attributes.content==='waterfall-chart') {
                              <waterfall-chart [config]="tile.attributes.parameters"
                                class="plotly-chart">
                              </waterfall-chart>
                            }
                            <!--End charts-->
                            @if (tile.attributes.content==='component-events-table') {
                              <component-events-table
                                [config]="tile.attributes.parameters"
                                [is_tile]="true"
                                (needToEdit)="openTileFormDialog($event)">
                              </component-events-table>
                            }
                            @if (tile.attributes.content==='context') {
                              <div style="height:100%;width:100%;">
                                <context [config]="tile.attributes.parameters"
                                  [show_header]="tile.attributes.show_header" [title]="tile.attributes.title">
                                </context>
                              </div>
                            }
                            @if (tile.attributes.content==='custom-events-table') {
                              <custom-events-table [config]="tile.attributes.parameters">
                              </custom-events-table>
                            }
                            @if (tile.attributes.content==='component-creator') {
                              <component-creator [config]="tile.attributes.parameters">
                              </component-creator>
                            }
                            @if (tile.attributes.content==='component-form') {
                              <component-form [config]="tile.attributes.parameters">
                              </component-form>
                            }
                            @if (tile.attributes.content==='custom-events') {
                              <event-sheet
                                [config]="tile.attributes.parameters">
                              </event-sheet>
                            }
                            @if (tile.attributes.content==='events') {
                              <events [config]="tile.attributes.parameters"></events>
                            }
                            @if (tile.attributes.content==='input-sheet') {
                              <input-data-sheet
                              [config]="tile.attributes.parameters"></input-data-sheet>
                            }
                            @if (tile.attributes.content==='julian-date') {
                              <julian-date [config]="tile.attributes.parameters"></julian-date>
                            }
                            @if (tile.attributes.content==='log-sheet') {
                              <log-sheet
                                [config]="tile.attributes.parameters">
                            </log-sheet>
                          }
                          @if (tile.attributes.content==='series-summary') {
                            <div style="height:100%;width:100%;">
                              <series-summary [config]="tile.attributes.parameters"
                                [show_header]="tile.attributes.show_header"
                                [title]="tile.attributes.title">
                              </series-summary>
                            </div>
                          }
                          @if (tile.attributes.content==='series-data-table') {
                            <series-data-table
                              [config]="tile.attributes.parameters">
                            </series-data-table>
                          }
                          @if (tile.attributes.content==='series-adjustment') {
                            <series-adjustment
                              [config]="tile.attributes.parameters">
                            </series-adjustment>
                          }
                          @if (tile.attributes.content==='series-table') {
                            <series-table
                              [config]="tile.attributes.parameters"
                              [ngClass]="tile.attributes.parameters.adjust_row_height? 'adjust-row-height':''">
                            </series-table>
                          }
                          @if (tile.attributes.content==='pending-context') {
                            <pending-context
                            [config]="tile.attributes.parameters"></pending-context>
                          }
                          <!--Pivot tables-->
                          @if (tile.attributes.content==='model-pivot-tile') {
                            <model-pivot-tile (tileContentChange)="saveState($event)"
                              [config]="tile.attributes.parameters"
                            [showUI]="false"></model-pivot-tile>
                          }
                          @if (tile.attributes.content==='pivot-tile') {
                            <pivot-tile [config]="tile.attributes.parameters" [showUI]="false"
                            (tileContentChange)="saveState($event)"></pivot-tile>
                          }
                          @if (tile.attributes.content==='pivot-tile-ng') {
                            <pivot-tile-ng (tileContentChange)="saveState($event)"
                              [config]="tile.attributes.parameters"
                            [showUI]="false"></pivot-tile-ng>
                          }
                          <!--End pivot tables-->
                          @if (tile.attributes.content==='upload-model') {
                            <upload-model [config]="tile.attributes.parameters"></upload-model>
                          }
                          @if (tile.attributes.content==='value-driver-tree' && dateInst.dtp) {
                            <value-driver-tree
                              [selected_calculation]="tile.attributes.parameters.selected_calculation"
                              [config]="tile.attributes.parameters"
                            [is_tile]="true"></value-driver-tree>
                          }
                          @if (tile.attributes.content==='weather-widget') {
                            <weather-widget></weather-widget>
                          }
                          <!--//TODO allow comments on series-table and input-sheet??-->
                          @if (tile.attributes.show_header!==false && !edit_mode && hideCommentButton(tile.attributes.content)) {
                            <div
        [button_class]="tile.attributes.content === 'series-table' ||
                tile.attributes.content === 'log-sheet' ||
                tile.attributes.content === 'input-sheet'"
                              class="comment-button">
                              <button (click)="toggleComments()"
                                [ngClass]="{'show-drawer': headerData.showing_comments && tileData.selected === true}"
                                class="icon-comment">
                              </button>
                            </div>
                          }
                          @if (tile.attributes.content==='category-chart') {
                            <category-chart
                            [config]="tile.attributes.parameters" class="chart"></category-chart>
                          }
                          @if (tile.attributes.content=='printout-mapper') {
                            <printout-mapper
                            [config]="tile.attributes.parameters"></printout-mapper>
                          }
                        </div><!--end tile-content-->
                      </div>
                    }
